import type { ProjectScope } from '../sync/project-scope.ts';
import {
    enqueueStructuredEntityWrite,
    type StructuredEntityWriteRegistration,
} from '../sync/structured-entity-write.ts';

type SoundWriteOptions = {
    actorId?: string;
};

function soundWriteRegistration(conflictPrefix: string): StructuredEntityWriteRegistration {
    return {
        feature: 'department_tracking',
        capability: 'EDIT_SOUND',
        conflictPrefix,
        allowedKinds: ['patchEntity', 'deleteEntity'],
        authErrorMessage: 'Authentication required to preserve sound project writes',
    };
}

const SOUND_CLIP_WRITE_REGISTRATION = soundWriteRegistration('soundClips');
const SOUND_CUE_WRITE_REGISTRATION = soundWriteRegistration('soundCues');
const MIC_ASSIGNMENT_WRITE_REGISTRATION = soundWriteRegistration('micAssignments');
const MIC_SWAP_WRITE_REGISTRATION = soundWriteRegistration('micSwaps');

async function deleteSoundEntity(
    scope: ProjectScope,
    entityId: string,
    registration: StructuredEntityWriteRegistration,
    options: SoundWriteOptions
): Promise<void> {
    await enqueueStructuredEntityWrite({
        scope,
        registration,
        entityId,
        kind: 'deleteEntity',
        payload: { id: entityId },
        actorId: options.actorId,
    });
}

export function deleteSoundClip(
    scope: ProjectScope,
    soundClipId: string,
    options: SoundWriteOptions = {}
): Promise<void> {
    return deleteSoundEntity(scope, soundClipId, SOUND_CLIP_WRITE_REGISTRATION, options);
}

export function deleteSoundCue(
    scope: ProjectScope,
    soundCueId: string,
    options: SoundWriteOptions = {}
): Promise<void> {
    return deleteSoundEntity(scope, soundCueId, SOUND_CUE_WRITE_REGISTRATION, options);
}

export function deleteMicAssignment(
    scope: ProjectScope,
    micAssignmentId: string,
    options: SoundWriteOptions = {}
): Promise<void> {
    return deleteSoundEntity(scope, micAssignmentId, MIC_ASSIGNMENT_WRITE_REGISTRATION, options);
}

export function deleteMicSwap(
    scope: ProjectScope,
    micSwapId: string,
    options: SoundWriteOptions = {}
): Promise<void> {
    return deleteSoundEntity(scope, micSwapId, MIC_SWAP_WRITE_REGISTRATION, options);
}
